export default __webpack_public_path__ + "static/media/Facebook.bc5cbe6c.svg";